/**
 * set cookie
 * @param  {String} cName name of the cookie
 * @param  {String} value  value of the cookie
 * @param  {Number} exdays number of days to set the cookie
 * @return {Function}      sets cookie
 */
function setCookie(cName, value, exdays) {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + exdays);
  const cValue = encodeURI(value)
    + ((exdays === null) ? '' : (`; expires=${exdate.toUTCString()}`));
  document.cookie = `${cName} = ${cValue}; path=/`;
};

/**
 * get cookie
 * @param  {String} cName name of the cookie
 * @return {String}        value of the cookie
 */
function getCookie(cName) {
  let i;
  let x;
  let y;
  const ARRcookies = document.cookie.split(';');
  for (i = 0; i < ARRcookies.length; i += 1) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
    x = x.replace(/^\s+|\s+$/g, '');
    if (x === cName) {
      return decodeURI(y);
    }
  }
  return false;
};

/**
 * delete cookie
 * @param {string} cName name of the cookie
 */
function deleteCookie(cName) {
  document.cookie = `${cName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

/**
 * updates discount cookie
 * @param  {String} discount discount code
 */
function updateDiscountsCookie(discount) {
  // Start of code to allow multiple discounts //
  let discountList = [];
  if (getCookie('elysium_discounts')) {
    discountList = JSON.parse(getCookie('elysium_discounts'));
  }
  if (!discountList.includes(discount)) discountList.push(discount);
  setCookie('elysium_discounts', JSON.stringify(discountList));
  // End of code to allow multiple discounts //
}

/**
 * updates checkout button to add discounts as params for checkout
 */
function attachCheckoutListener() {
  const checkoutButton = document.querySelector(".cart__checkout-button.button");
  if (!checkoutButton) return;
  checkoutButton.addEventListener("click", e => {
    e.preventDefault();
    // Start of code to allow multiple discounts //
    let codes = [];
    if (getCookie('discount_code')) codes.push(getCookie('discount_code'));
    if (getCookie('elysium_discounts')) codes = codes.concat(JSON.parse(getCookie('elysium_discounts')));
      
    if (codes.length > 0) {
      window.location.href = '/checkout?discount=' + codes.join(',');
    } else {
      window.location.href = '/checkout';
    }
    // End of code to allow multiple discounts //
  })
}

window.addEventListener("delayedLoad", e => {
  attachCheckoutListener();
  const observer = new MutationObserver(attachCheckoutListener);

  observer.observe(document.querySelector("cart-drawer"), {
    subtree: true,
    childList: true,
  });
})